import { useAuth0 } from "@auth0/auth0-react";
import React from "react";

export const LoginButton = ({
  className,
  text
}) => {
  const { loginWithRedirect } = useAuth0();

  const handleLogin = async () => {
    await loginWithRedirect({
      appState: {
        returnTo: "/profile",
      },
    });
  };

  return (
    <button className={`${className ? className : "button button-small button-blue"}`} onClick={handleLogin}>
      {text ? text : "Log In"}
    </button>
  );
};